<template>
  <div>
    <div class="text-h3 mb-2">Zvolte si plán přesně podle svých potřeb</div>
    <div class="text-body-2 mb-6">
      Myslíte to s námi vážně? Předplaťte si adveroo na
      <strong>14 měsíců za cenu 12</strong>! Při volbě kteréhokoli plánu od nás
      dostánete <strong>7 dní na vykoušení ZDARMA</strong>.
    </div>
    <v-row>
      <v-col v-for="(plan, index) in plans" :key="index" cols="12" md="5">
        <div
          @click="onSelect(plan.id)"
          :class="[
            'white rounded check-card px-6 py-10 d-flex flex-column fill-height cursor-pointer',
            selected === plan.id
              ? 'check-card--active'
              : 'shadow shadow--hover',
          ]"
          :style="{ '--c-accent-color': 'var(--v-amber-lighten1)' }"
        >
          <div class="text-center mb-8">
            <div class="text-h4 mb-1" v-text="plan.title" />
            <div class="body-1 font-weight-bold" v-text="plan.subtitle" />
          </div>
          <ul class="mb-auto list-reset">
            <li
              v-for="(feature, featureIndex) in plan.features"
              :key="featureIndex"
              class="my-2"
            >
              <v-icon color="green" small class="mr-2">mdi-check</v-icon>
              {{ feature }}
            </li>
          </ul>
          <v-divider class="my-12" />
          <div class="text-center">
            <div class="text-h3 mb-1">
              {{ plan.price }}&nbsp;Kč{{ plan.footnote ? "*" : "" }}
            </div>
            <div class="text-caption navyGray--text">
              měsíčně a bez DPH
            </div>
            <div class="text-caption navyGray--text mb-6">
              {{ plan.afterPrice }}
            </div>
            <div class="text-caption amber--text cursor-pointer">
              {{ selected === plan.id ? "Odebrat plán" : "Vybrat plán" }}
            </div>
          </div>
        </div>
        <div v-if="plan.footnote" class="mt-4">* {{ plan.footnote }}</div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
const plans = [
  {
    id: "24452d24-a39e-48a0-b6fe-c89e3947b9dd",
    title: "Měsíční členství",
    subtitle: "adveroo Standard",
    price: 490,
    afterPrice: "593 Kč měsíčně s DPH",
    features: [
      "Neomezený přístup k aplikaci odkudkoliv",
      "Jeden uživatelský účet",
      "Libovolný reklamní rozpočet",
      "Neomezený počet kampaní, reklam",
      "Podpora 8-18 v pracovních dnech",
    ],
  },
  {
    id: "b97569f7-86e8-4914-9f61-14de3dde368f",
    title: "Roční členství",
    subtitle: "adveroo Member",
    price: 420,
    afterPrice: "7 115 Kč ročně s DPH",
    footnote: "Při platbě na 12 měsíců získáte 2 měsíce zdarma navíc.",
    features: [
      "Neomezený přístup k aplikaci odkudkoliv",
      "Jeden uživatelský účet",
      "Libovolný reklamní rozpočet",
      "Neomezený počet kampaní, reklam",
      "Podpora 8-18 v pracovních dnech",
      // "Přístup k adveroo academy",
      "Sleva 15 % oproti adveroo Standard",
    ],
  },
]

export default {
  model: {
    prop: "selected",
    event: "click",
  },
  props: {
    selected: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      plans,
    }
  },
  methods: {
    onSelect(id) {
      this.$emit("click", id)
    },
  },
}
</script>
